import Pivot from './Pivot.vue';

import AllView from "./views/all";
// import OrderView from "./views/order";
// import InvoiceView from "./views/invoice";
import HistoryView from "./views/history";
import PackageView from "./views/package";
import PackageHardwareOnlyView from "./views/packageHardwareOnly";
// import SubscriptionView from "./views/subscription";
import ShippingView from "./views/shipping";

const BaseViews: any = {
  "all": new AllView(),
  // 'order': new OrderView(),
  "package": new PackageView(),
  "shipping": new ShippingView(),
  "package-hardware": new PackageHardwareOnlyView(),
  // 'invoice': new InvoiceView(),
  'history': new HistoryView(),
  // 'subscription': new SubscriptionView()
};

export {
  BaseViews
};

export default Pivot;
